import { useState } from 'react';
import { fields, profileImage, resumeUrl, ribbon, socials } from './data';
import Field from './Field';
import { SocialIcon } from './Icons';

function externalProps(href) {
  if (!href.startsWith('http')) return {};
  return { target: '_blank', rel: 'noreferrer noopener' };
}

export default function Hero() {
  const [photoFailed, setPhotoFailed] = useState(false);

  return (
    <section className="hero" id="top">
      <div className="aurora" aria-hidden="true">
        <i />
        <i />
        <i />
      </div>
      <Field />
      <div className="wrap hero__grid">
        <div className="hero__copy">
          <p className="sr-only">
            Ayush Kumawat is an AI and ML engineer in Pune. His work spans space systems, education technology,
            infrastructure monitoring, and surveillance.
          </p>
          <p className="eyebrow">
            <i />
            AI & ML engineer · Pune
          </p>
          <h1>
            <span className="hero__line">Ayush</span>
            <span className="hero__line">Kumawat</span>
          </h1>
          <p className="hero__lead">AI and ML for space systems, classrooms, road networks, and surveillance.</p>
          <div className="hero__jumps">
            {fields.map((field) => (
              <a key={field.id} href={`#${field.id}`}>
                {field.label}
              </a>
            ))}
          </div>
          <div className="hero__actions">
            <a className="btn btn--solid" href="#work">
              View the work
            </a>
            <a className="btn btn--ghost" href="#contact">
              Contact
            </a>
            <a className="textlink" href={resumeUrl} target="_blank" rel="noreferrer">
              Resume
            </a>
          </div>
          <div className="socials">
            {socials.map((item) => (
              <a key={item.label} href={item.href} aria-label={item.label} {...externalProps(item.href)}>
                <SocialIcon name={item.label} />
              </a>
            ))}
          </div>
        </div>
        <div className="stage">
          <div className="halo">
            <span className="halo__ring" aria-hidden="true" />
            <figure className="portrait">
              <div className="portrait__frame">
                {photoFailed ? (
                  <span className="portrait__fallback">AK</span>
                ) : (
                  <img
                    src={profileImage}
                    alt="Ayush Kumawat standing on a mountain trail"
                    fetchPriority="high"
                    decoding="async"
                    onError={() => setPhotoFailed(true)}
                  />
                )}
              </div>
            </figure>
          </div>
          <p className="stage__caption">Pune · two years</p>
        </div>
      </div>
      <div className="ribbon" aria-hidden="true">
        <div className="ribbon__track">
          {[0, 1].map((copy) => (
            <div className="ribbon__group" key={copy}>
              {ribbon.map((item) => (
                <span key={`${copy}-${item}`}>{item}</span>
              ))}
            </div>
          ))}
        </div>
      </div>
    </section>
  );
}
